// extracted by mini-css-extract-plugin
export default {"label":"Search_label__0N8jK","input":"Search_input__hCkME"};